import { useCallback, useState } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Work from "@/components/site/Work";
import Manifesto from "@/components/site/Manifesto";
import Approach from "@/components/site/Approach";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [isDesktop] = useState(() => (typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia("(min-width: 768px)").matches : true));



  const onNav = useCallback((id) => {
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <main data-testid="home-page" style={{ background: "var(--bone)", color: "var(--ink)" }}>
      <Nav onNav={onNav} />
      <Hero onNav={onNav} />
      {isDesktop ? <Manifesto /> : null}
      <Work />
      <Approach />
      <Contact />
      <Footer />
    </main>
  );
}
